import { render, staticRenderFns } from "./awaitingApprovalHomePageCard.vue?vue&type=template&id=ee130a66&"
import script from "./awaitingApprovalHomePageCard.vue?vue&type=script&lang=js&"
export * from "./awaitingApprovalHomePageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports